import concernIcon from "../../../assets/icons/progress/icon_progressbar_vertrag.svg";
import documentsIcon from "../../../assets/icons/progress/icon_progressbar_vertrag_upload.svg";

const progressBarSteps = [
  {
    key: "concern",
    name: "Ihr Arbeitsverhältnis",
    icon: concernIcon,
  },
  {
    key: "documents",
    name: "Unterlagen",
    icon: documentsIcon,
  },
];

export default progressBarSteps;
